export enum OrderCargoOrderFinishedListRequestOrder {
  START_TIME_ASC = "START_TIME_ASC",
  START_TIME_DESC = "START_TIME_DESC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
}

export enum OrderCargoOrderFinishedListRequestPublicStatus {
  PRIVATE = "PRIVATE",
  PUBLISHED = "PUBLISHED",
  PUBLIC = "PUBLIC",
}

export type OrderCargoOrderFinishedListRequestQueryParams = {
  isCancelled?: boolean;
  isApproved?: boolean;
  client?: string[];
  dispatch?: string[];
  driver?: string[];
  externalId?: string[];
  address?: string[];
  startAddress?: string[];
  midAddress?: string[];
  endAddress?: string[];
  taxi?: string[];
  passenger?: string[];
  publicStatus?: OrderCargoOrderFinishedListRequestPublicStatus;
  order?: OrderCargoOrderFinishedListRequestOrder;
  offset?: number;
  limit?: number;
  startTimeSince?: Date;
  startTimeTo?: Date;
  humanId?: number[];
  fleetPartners?: string[];
  excludeFleetPartners?: string[];
};

type OrderCargoOrderFinishedListRequest = {
  internalOrderId?: number[];
  isCancelled?: boolean;
  isApproved?: boolean;
  startTimeSince?: Date;
  startTimeTo?: Date;
  client?: string[];
  dispatch?: string[];
  driver?: string[];
  externalId?: string[];
  address?: string[];
  startAddress?: string[];
  midAddress?: string[];
  endAddress?: string[];
  taxi?: string[];
  passenger?: string[];
  fleetPartners?: string[];
  excludeFleetPartners?: string[];
  publicStatus?: OrderCargoOrderFinishedListRequestPublicStatus;
  order?: OrderCargoOrderFinishedListRequestOrder;
  offset?: number;
  limit?: number;
};

export default OrderCargoOrderFinishedListRequest;
